contaApp.controller('NoticeSingleController', ['$scope', '$http', '$filter', function($scope, $http, $filter, $visits) {

    $scope.viewNoticeList = function () {
    	$scope.mostrarVista('noticesListView');

    };

}]);
